// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SuWpp","label":"styles_label__Vn3sa"};